import React from 'react'
import styles from "./Resources.module.scss";
import { checklist } from "../../configration_data/configration"
import { useNavigate } from 'react-router-dom';
import ProtectedPaymentRoute from '../../auth/Auth';

export default function Checklist() {
  ProtectedPaymentRoute()

  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/services/llc-formation")
  }

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">

      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            Step-by-Step Business Checklist
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            Everything you need to validate, register, license, and launch your business with complete compliance.
          </p>
        </div>
      </section>

      {/* Overview & Grid Section */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">Comprehensive Roadmap</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">What is BOI and Why is it Important?</h2>
            <p className="text-[17px] text-[#5f6368] leading-relaxed">
              Beneficial Ownership Information (BOI) filing is a regulatory requirement designed to increase transparency in business ownership. Understanding BOI is crucial for compliance and maintaining the integrity of your business.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {checklist.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-white rounded-[12px] p-8 border border-[#dadce0] shadow-sm hover:border-[#1a73e8] hover:shadow-[0_12px_30px_rgba(26,115,232,0.12)] transition-all duration-300 flex flex-col justify-between group hover:-translate-y-1"
              >
                <div>
                  {/* Step Number Badge */}
                  <div className="flex items-center justify-between mb-6">
                    <span className="text-[32px] font-bold text-[#1a73e8] leading-none tracking-tight">
                      {ele.number}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] opacity-0 group-hover:opacity-100 transition-opacity">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                    </div>
                  </div>

                  <h3 className="text-[20px] font-medium text-[#202124] mb-3 tracking-tight group-hover:text-[#1a73e8] transition-colors">
                    {ele.title}
                  </h3>
                  
                  <div className="text-[#5f6368] text-[15px] leading-relaxed [&_a]:text-[#1a73e8] [&_a]:font-medium [&_a]:underline hover:[&_a]:text-[#1557b0]">
                    {ele.para}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Box Section */}
      <section className="py-20 lg:py-24 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-2xl mx-auto bg-[#f8f9fa] p-8 lg:p-12 rounded-[16px] border border-[#dadce0] text-center flex flex-col items-center">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">Ready to Form Your Business?</span>
            <h3 className="text-[28px] font-medium text-[#202124] mb-3">Let us handle the paperwork for you</h3>
            <p className="text-[15px] text-[#5f6368] mb-8 max-w-lg leading-relaxed">From LLC registration and EIN acquisition to BOI compliance, our experts make starting your company seamless.</p>
            <button 
              onClick={handleClick}
              className="bg-[#1a73e8] text-white px-9 py-3.5 rounded-[4px] font-medium text-[15px] hover:bg-[#1557b0] transition-colors shadow-md cursor-pointer"
            >
              Start LLC Formation
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
